export const MESSAGE_IN_VIEW_THRESHOLD = 0.1;
